import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ProductService } from 'src/app/shared/services/product.service';
import { take } from 'rxjs/operators';
import * as _ from "lodash";
@Component({
	selector: 'app-branches-info',
	templateUrl: './branches.component.html',
	styleUrls: ['./branches.component.scss']
})
export class BranchesComponent implements OnInit {
	toppingForm: FormGroup;
	submitted = false;
	branches;
	choosenBranch;
	choosenBranchGroupForm: FormGroup;
	constructor(private producService: ProductService, private formBuilder: FormBuilder) { }
	ngOnInit() {
		this.producService.getBranchesObject().valueChanges().subscribe(branches => {
			this.branches = branches;
		});
	}


	chooseBranch(branch) {
		if (_.isNil(branch)) { return; }
		let s = _.map(this.branches, (value, key) => {
			if (key == branch.key) {
				return { ...value, key }
			}
		});
		s = _.filter(s, (branch) => { return branch !== undefined });
		this.choosenBranch = s[0];
		this.choosenBranchGroupForm = this.formBuilder.group({
			branchId: [this.choosenBranch.branchId, Validators.required],
			branchName: [this.choosenBranch.branchName, Validators.required],
			deliveryFee: [this.choosenBranch.deliveryFee, Validators.required],
			productAdded: moment().unix()
		}, {
		});
	}
	get f() { return this.choosenBranchGroupForm.controls; }

	onSubmit() {
		this.submitted = true;
		// stop here if form is invalid
		if (this.choosenBranchGroupForm.invalid) {
			return;
		}
		this.producService.updateBranch(this.choosenBranchGroupForm.value, this.choosenBranch.key)
	}
	onReset() {
		this.submitted = false;
		this.choosenBranchGroupForm.reset();
	}

}